const isElementClippingAnotherElement = (child: HTMLDivElement, parent: HTMLDivElement) => {
	const parentRect = parent.getBoundingClientRect();
	const childRect = child.getBoundingClientRect();

	return (
		childRect.left < parentRect.left ||
		childRect.right > parentRect.right ||
		childRect.top < parentRect.top ||
		childRect.bottom > parentRect.bottom
	);
};

export default isElementClippingAnotherElement;
